import styled from "styled-components";

import { getToneTokens } from "../../styles/shared";

export const TagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

// Mesmo desenho dos chips de tags do cockpit do lead: a pessoa reconhece o
// componente de um cadastro no outro.
export const TagChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.74rem;
  background: ${({ theme }) => getToneTokens(theme, "info").background};
  color: ${({ theme }) => getToneTokens(theme, "info").text};
  border: 1px solid ${({ theme }) => getToneTokens(theme, "info").border};

  > button {
    appearance: none;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    font-size: 0.9rem;
  }
`;

export const LinhaDeEntrada = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 4px;

  > input {
    flex: 1;
    min-width: 0;
  }
`;
